import React, { useState } from 'react';
import { useNavigate, useLocation, Outlet } from 'react-router-dom';
import { Box, Drawer, AppBar, Toolbar, Typography, List, ListItem, ListItemButton,
  ListItemIcon, ListItemText, IconButton, Divider, Chip } from '@mui/material';
import { Menu as MenuIcon, Dashboard, Description, AccountBalance, Work, Euro, Assessment, Event, FolderOpen, Logout, Person } from '@mui/icons-material';
import { useAuth } from '../../context/AuthContext';

const drawerWidth = 280;

const menuItems = [
  { text: 'Dashboard', icon: <Dashboard />, path: '/' },
  { text: 'Anträge', icon: <Description />, path: '/antraege' },
  { text: 'Fördergeber', icon: <AccountBalance />, path: '/foerdergeber' },
  { text: 'Projekte', icon: <Work />, path: '/projekte' },
  { text: 'Finanzen', icon: <Euro />, path: '/finanzen' },
  { text: 'Berichte', icon: <Assessment />, path: '/sachberichte' },
  { text: 'Veranstaltungen', icon: <Event />, path: '/veranstaltungen' },
  { text: 'Dokumente', icon: <FolderOpen />, path: '/dokumente' },
];

const isHttps = window.location.protocol === 'https:';

const Layout = () => {
  const [mobileOpen, setMobileOpen] = useState(false);
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  const handleLogout = () => { logout(); navigate('/login'); };

  const drawer = (
    <Box>
      <Box sx={{ p: 2, bgcolor: '#1B5E20' }}>
        <Typography variant="h6" sx={{ color: 'white', fontWeight: 'bold' }}>IAN Verwaltung</Typography>
        <Typography variant="caption" sx={{ color: '#A5D6A7' }}>
          {user?.firstName} {user?.lastName}
        </Typography>
      </Box>
      <List>
        {menuItems.map((item) => (
          <ListItem key={item.text} disablePadding>
            <ListItemButton selected={location.pathname === item.path}
              onClick={() => { navigate(item.path); setMobileOpen(false); }}
              sx={{ '&.Mui-selected': { bgcolor: '#E8F5E9', borderRight: '3px solid #1B5E20' } }}>
              <ListItemIcon sx={{ color: location.pathname === item.path ? '#1B5E20' : '#666' }}>
                {item.icon}
              </ListItemIcon>
              <ListItemText primary={item.text} />
            </ListItemButton>
          </ListItem>
        ))}
      </List>
      <Divider />
      <List>
        <ListItem disablePadding>
          <ListItemButton onClick={handleLogout}>
            <ListItemIcon><Logout /></ListItemIcon>
            <ListItemText primary="Abmelden" />
          </ListItemButton>
        </ListItem>
      </List>
    </Box>
  );

  return (
    <Box sx={{ display: 'flex' }}>
      {/* Dev-Banner */}
      {!isHttps && (
        <Box sx={{ position: 'fixed', top: 0, left: 0, right: 0, zIndex: 1300,
          bgcolor: '#FFF3E0', color: '#E65100', textAlign: 'center', py: 0.3,
          fontSize: '0.75rem', fontWeight: 500, borderBottom: '1px solid #FFB74D' }}>
          Entwicklungsmodus – keine sichere Verbindung
        </Box>
      )}
      <AppBar position="fixed" sx={{ zIndex: 1201, bgcolor: '#1B5E20', top: !isHttps ? '28px' : 0 }}>
        <Toolbar>
          <IconButton color="inherit" edge="start" onClick={() => setMobileOpen(!mobileOpen)}
            sx={{ mr: 2, display: { md: 'none' } }}>
            <MenuIcon />
          </IconButton>
          <Typography variant="h6" noWrap sx={{ flexGrow: 1 }}>
            Islamische Akademie NRW
          </Typography>
          {user && (
            <Chip icon={<Person sx={{ color: '#A5D6A7 !important' }} />}
              label={`${user.firstName} ${user.lastName}`}
              sx={{ color: 'white', borderColor: '#A5D6A7', '& .MuiChip-label': { color: 'white' } }}
              variant="outlined" size="small" />
          )}
        </Toolbar>
      </AppBar>
      <Drawer variant="temporary" open={mobileOpen} onClose={() => setMobileOpen(false)}
        sx={{ display: { xs: 'block', md: 'none' }, '& .MuiDrawer-paper': { width: drawerWidth, mt: !isHttps ? '28px' : 0 } }}>
        {drawer}
      </Drawer>
      <Drawer variant="permanent"
        sx={{ display: { xs: 'none', md: 'block' }, '& .MuiDrawer-paper': { width: drawerWidth, boxSizing: 'border-box', mt: !isHttps ? '28px' : 0 } }}>
        <Toolbar />
        {drawer}
      </Drawer>
      <Box component="main" sx={{ flexGrow: 1, p: 3, mt: !isHttps ? '92px' : 8, ml: { md: `${drawerWidth}px` }, bgcolor: '#FAFAFA', minHeight: '100vh' }}>
        <Outlet />
      </Box>
    </Box>
  );
};

export default Layout;
